<template>
  <div>
    <!-- 达人投稿视频 -->
    <div v-if="formKey === 'star_task_author_videos'">
      <div class="flex items-center">
        <el-button type="primary" @click="openStarTaskAuthorVideos(formItem)">添加投稿视频</el-button>
        <i v-if="Object.keys(formItem.value || {}).length" class="el-icon-success app-check-icon-success ml-10" />
      </div>
      <el-dialog
        title="达人投稿视频配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="1000px"
      >
        <star-task-author-videos-list v-if="formItem.is_open" :form-item="formItem" :init-ops="initOps" v-bind="getComponentProps(formKey)" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirmStarTaskAuthorVideos(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'star-task-author-videos-list': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/creative-config/creative-components/channel-interface/jrtt/components/star-task-author-videos/components/star-task-author-videos-list/index.vue'),
  },
  props: {
    // 表单项键名
    formKey: {
      type: String,
      required: true,
    },
    // 表单项配置
    formItem: {
      type: Object,
      required: true,
    },
    // 初始化数据
    initOps: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  created() {

  },
  methods: {
    /**
     * 获取组件props
     * @param {string} form_key 表单键
     * @returns {Object}
     */
    getComponentProps(form_key) {
      const strategy = {
        star_task_author_videos: () => {
          const { advertiser_id, campaign: { delivery_mode, star_task_switch, star_task_id }} = this.row;

          /**
           * - 投放方式为手动投放流程下最大选取数量：10
           * - 投放方式为自动投放流程下最大选取数量：30
           */
          const max_selection_count_map = {
            MANUAL: 10,
            PROCEDURAL: 30,
          };

          const star_tasks_value = { [advertiser_id]: [{ id: star_task_id }] };

          return {
            advertiserId: advertiser_id,
            starTaskSwitch: star_task_switch,
            starTasks: star_tasks_value,
            maxSelectionCount: max_selection_count_map[delivery_mode] || max_selection_count_map['PROCEDURAL'],
          };
        },
        default: () => {},
      };

      return (strategy[form_key] || strategy['default'])();
    },
    /**
     * 打开投稿视频
     * @param form_item 表单项
     * @returns {void}
     */
    openStarTaskAuthorVideos(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.filter_config_backup = JSON.parse(JSON.stringify(form_item.filter_config));
      form_item.is_open = true;
    },
    /**
     * 投稿视频配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    confirmStarTaskAuthorVideos(form_item) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      const is_valid = Object.values(result).every(v => v.length);
      if (is_valid) {
        form_item.value = result;
        form_item.filter_config = JSON.parse(JSON.stringify(form_item.filter_config_backup));
        form_item.is_open = false;
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
  },
};
</script>
